import React, { useState } from "react";
import Swal from "sweetalert";
import { AiOutlineClose } from "react-icons/ai";
import { BiRename } from "react-icons/bi";
import { BiLogoGmail } from "react-icons/bi";
import { signupUser, userLogin, verifyOTP } from "../../api/fetch";
import { useAuth } from "../../services/AuthContext";

const SignIn = ({ isOpen, onClose }) => {
  const { customerUser, setCustomerUser } = useAuth();

  const [isSignUp, setIsSignUp] = useState(false);
  const [showOTP, setShowOTP] = useState(false);
  const [loading, setLoading] = useState(false);

  const [mobileNo, setMobileNumber] = useState("");
  const [fullName, setFullName] = useState("");
  const [emailAddress, setEmailAddress] = useState("");
  const [otp, setOtp] = useState(["", "", "", ""]);

  // For Error Message
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    let newErrors = {};

    if (isSignUp) {
      if (!fullName.trim()) {
        newErrors.fullName = "Please enter your full name.";
      } else if (fullName.length < 3) {
        newErrors.fullName = "Full name must be at least 3 characters long.";
      }
      if (!emailAddress.trim()) {
        newErrors.emailAddress = "Please enter your email address.";
      } else if (emailAddress.length < 5) {
        newErrors.emailAddress =
          "Email address must be at least 5 characters long.";
      } else if (!/\S+@\S+\.\S+/.test(emailAddress)) {
        newErrors.emailAddress = "Please enter a valid email address.";
      }
    }

    if (!mobileNo) {
      newErrors.mobileNo = "Please enter your mobile number.";
    } else if (!mobileNo.match(/^\d{10}$/)) {
      newErrors.mobileNo = "Mobile number must be exactly 10 digits.";
    }

    if (showOTP) {
      const joinedOtp = otp.join("");
      if (!joinedOtp) {
        newErrors.otp = "Please enter the OTP sent to your mobile number.";
      } else if (!joinedOtp.match(/^\d{4}$/)) {
        newErrors.otp = "OTP must be a 4-digit number.";
      }
    }

    // Set errors
    setErrors(newErrors);

    // Return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  const toggleForm = () => {
    setIsSignUp(!isSignUp);
  };

  const handleChange = (value, index) => {
    if (value.length > 1) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    // Focus on the next input if not the last
    if (value && index < 3) {
      document.getElementById(`otp-input-${index + 1}`).focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      document.getElementById(`otp-input-${index - 1}`).focus();
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateForm();
    if (isValid) {
      setLoading(true);
      try {
        var formData = {
          mobile_number: mobileNo,
        };
        const res = await userLogin(formData);
        console.log("RESSS ::", res);

        if (res?.status) {
          setShowOTP(true);
        } else {
          setErrors({ mobileNo: res?.msg });
        }
      } catch (error) {
        console.log("Eroror :::", error);
      }
      setLoading(false);
    }
  };

  const handleOTPSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateForm();
    if (isValid) {
      setLoading(true);
      try {
        const otpValue = otp.join("");
        var formData = {
          mobile_number: mobileNo,
          otp: otpValue,
        };
        const res = await verifyOTP(formData);
        console.log("RESSS ::", res);

        if (res?.status) {
          setCustomerUser(res?.user);
          localStorage.setItem("userToken", res?.access_token);

          Swal({
            title: "Success",
            text: res?.msg + " " + "Login Successfully.",
            timer: 1000,
            icon: "success",
          });
          onClose();
          setShowOTP(false);
        } else {
          setErrors({ otp: res?.msg });
        }
      } catch (error) {
        console.log("Eroror :::", error);
      }
      setLoading(false);
    }

    // onSubmit(otpValue);
  };

  const handleSignUpSubmit = async (e) => {
    e.preventDefault();

    const isValid = validateForm();

    if (isValid) {
      setLoading(true);
      try {
        var formData = {
          name: fullName,
          mobile_number: mobileNo,
          email_address:emailAddress
        };
        const res = await signupUser(formData);
        console.log("RESSS ::", res);

        if (res?.status) {
          setShowOTP(true);
          setErrors({ msg: res?.msg });
        } else {
          setErrors({ mobileNo: res?.msg });
        }
      } catch (error) {
        console.log("Eroror :::", error);
      }
      setLoading(false);
    }
  };

  return (
    <>
      {isOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-70 backdrop-blur-sm flex items-center justify-center z-50 font-Poppins">
          <div className="bg-yellow-400 rounded-xl shadow-2xl p-8 w-full max-w-md relative transform transition-all">
            {/* Close Icon */}
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-black hover:text-gray-700 transition-colors"
            >
              <AiOutlineClose size={28} />
            </button>

            {/* Title */}
            <h2 className=" md:text-3xl text-xl font-extrabold text-black text-center mb-4 tracking-wide">
              {isSignUp ? "Join Us" : "Welcome"}
            </h2>

            <p className="text-gray-800 text-center mb-6">
              {isSignUp
                ? "Sign up with your mobile number to start your journey."
                : "Enter your mobile number to sign in."}
            </p>

            {/* Form */}
            <form className="space-y-6">
              {isSignUp && (
                <>
                  <div className="relative">
                    <label className="block text-sm font-semibold text-gray-900 mb-2">
                      Full Name
                    </label>
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 font-semibold">
                        <BiRename size={"23"} />
                      </span>
                      <input
                        type="text"
                        placeholder="Enter your full name"
                        className="w-full pl-12 p-3 border border-black rounded-lg focus:ring-2 focus:ring-black focus:outline-none text-gray-900 text-lg"
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                      />
                    </div>

                    <div>
                      {errors?.fullName && (
                        <p className="text-red-500 text-md mt-1">
                          {errors?.fullName}
                        </p>
                      )}
                    </div>
                  </div>
                  <div className="relative">
                    <label className="block text-sm font-semibold text-gray-900 mb-2">
                      Email Address
                    </label>
                    <div className="relative">
                      <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 font-semibold">
                        <BiLogoGmail size={23} />
                      </span>
                      <input
                        type="text"
                        placeholder="Enter your Email Address"
                        className="w-full pl-12 p-3 border border-black rounded-lg focus:ring-2 focus:ring-black focus:outline-none text-gray-900 text-lg"
                        value={emailAddress}
                        onChange={(e) => setEmailAddress(e.target.value)}
                      />
                    </div>

                    <div>
                      {errors?.emailAddress && (
                        <p className="text-red-500 text-md mt-1">
                          {errors?.emailAddress}
                        </p>
                      )}
                    </div>
                  </div>
                </>
              )}
              <div className="relative">
                <label className="block text-sm font-semibold text-gray-900 mb-2">
                  Mobile Number
                </label>
                <div className="relative">
                  <span className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500 font-semibold">
                    +91
                  </span>
                  <input
                    type="tel"
                    placeholder="Enter your mobile number"
                    className="w-full pl-12 p-3 border border-black rounded-lg focus:ring-2 focus:ring-black focus:outline-none text-gray-900 text-lg tracking-wide"
                    value={mobileNo}
                    maxLength={10}
                    onChange={(e) => {
                      const value = e.target.value.replace(/\D/g, "");
                      setMobileNumber(value);
                    }}
                  />
                </div>
                <div>
                  {errors?.mobileNo && (
                    <p className="text-red-500 text-md mt-1">
                      {errors?.mobileNo}
                    </p>
                  )}
                </div>

                {showOTP && (
                  <div className="my-3 animate-fadeIn">
                    {/* Title */}
                    <h2 className="text-xl font-bold text-gray-800 text-center mb-2">
                      Enter OTP
                    </h2>
                    <p className="text-gray-600 text-center text-sm text-base mb-5">
                      We’ve sent a 4-digit OTP to your Registrator Email Address.
                    </p>
                    {/* OTP Inputs */}
                    <div className="flex justify-center gap-6 transition-all duration-500 ease-in-out">
                      {otp.map((digit, index) => (
                        <input
                          key={index}
                          id={`otp-input-${index}`}
                          type="text"
                          maxLength={1}
                          value={digit}
                          onChange={(e) => handleChange(e.target.value, index)}
                          onKeyDown={(e) => handleKeyDown(e, index)}
                          className="w-16 h-16 text-center text-2xl font-bold border border-black rounded-lg focus:ring-2 focus:ring-black focus:outline-none text-gray-900 transition-transform transform hover:scale-105"
                        />
                      ))}
                    </div>

                    <div>
                      {errors?.otp && (
                        <p className="text-red-500 text-md mt-2 text-center font-medium animate-pulse">
                          {errors?.otp}
                        </p>
                      )}
                    </div>
                  </div>
                )}
              </div>

              <div>
                {errors?.msg && (
                  <p className="text-red-500 text-md mt-2 text-center font-medium ">
                    {errors?.msg}
                  </p>
                )}
              </div>

              <button
                onClick={
                  showOTP
                    ? handleOTPSubmit
                    : isSignUp
                    ? handleSignUpSubmit
                    : handleSubmit
                }
                className="w-full py-3 bg-black text-yellow-400 font-bold text-lg rounded-lg hover:bg-gray-900 transition-transform transform hover:scale-105"
              >
                {loading ? (
                  <>
                    <span className="flex items-center justify-center">
                      <svg
                        className="animate-spin h-5 w-5 mr-2 text-yellow-400"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                      >
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        ></circle>
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8v4a4 4 0 100 8v4a8 8 0 01-8-8z"
                        ></path>
                      </svg>
                    </span>
                  </>
                ) : (
                  <>
                    {showOTP ? "Verify OTP" : isSignUp ? "Sign Up" : "Sign In"}
                  </>
                )}
              </button>
            </form>

            {/* Toggle */}
            <p className="text-center text-gray-900 mt-6">
              {isSignUp ? (
                <>
                  Already have an account?{" "}
                  <button
                    onClick={toggleForm}
                    className="text-black font-bold underline"
                  >
                    Sign In
                  </button>
                </>
              ) : (
                <>
                  Don’t have an account?{" "}
                  <button
                    onClick={toggleForm}
                    className="text-black font-bold underline"
                  >
                    Sign Up
                  </button>
                </>
              )}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default SignIn;
